import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { AddonFormView } from "../features/menu/addon-form";
import { BackToMenu } from "../features/menu/back-link";
import { useInPanes } from "../features/menu/panes";
import { Require } from "../features/require";

export const Route = createFileRoute("/menu/addons/new")({ component: Page });

function Page() {
	const navigate = useNavigate();
	const inPanes = useInPanes();
	return (
		<Require permission="menu.edit">
			<div className="max-w-3xl">
				<AddonFormView
					groupId={null}
					back={<BackToMenu to="/menu/addons" />}
					onSaved={(group) =>
						void navigate(
							inPanes
								? { to: "/menu/addons/$groupId", params: { groupId: group.id } }
								: { to: "/menu/addons" },
						)
					}
					onDeleted={() => void navigate({ to: "/menu/addons" })}
				/>
			</div>
		</Require>
	);
}
